'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _FollowUserButton = require('../../FollowUserButton');

var _FollowUserButton2 = _interopRequireDefault(_FollowUserButton);

var _propTypes = require('../../../shared/prop-types');

var _actionCreators = require('../../../store/actions/action-creators');

var _feedUserUtil = require('../../../utils/feed-user-util');

var _feedUserUtil2 = _interopRequireDefault(_feedUserUtil);

var _feedUserType = require('../../../shared/feed-user-type');

var _feedUserType2 = _interopRequireDefault(_feedUserType);

var _Uniform = require('../../Uniform');

require('./_follow-user-link.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FollowUserLink = function (_PureComponent) {
  _inherits(FollowUserLink, _PureComponent);

  function FollowUserLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FollowUserLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FollowUserLink.__proto__ || Object.getPrototypeOf(FollowUserLink)).call.apply(_ref, [this].concat(args))), _this), _this.onClickProfile = function () {
      var feedUserId = _this.props.feedUser.feedUserId;

      _this.props.showMiniProfile(feedUserId.type, feedUserId.relatedId);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FollowUserLink, [{
    key: 'shouldShowFollowButton',
    value: function shouldShowFollowButton() {
      // Show the follow button if the user is logged in and this isn't the current user
      var _props = this.props,
          currentUserId = _props.currentUserId,
          feedUser = _props.feedUser;

      return currentUserId && (feedUser.feedUserId.type !== _feedUserType2.default.User || feedUser.feedUserId.relatedId !== this.props.currentUserId);
    }
  }, {
    key: 'render',
    value: function render() {
      var feedUser = this.props.feedUser;

      var name = _feedUserUtil2.default.getFeedUserName(feedUser);
      var initials = _feedUserUtil2.default.getFeedUserInitials(name);
      var profileImage = _feedUserUtil2.default.getFeedUserAvatar(feedUser);

      return _react2.default.createElement(
        'div',
        { className: 'follow-feeduser-link' },
        _react2.default.createElement(
          'div',
          { className: 'feeduser-wrapper feed-user-data' },
          _react2.default.createElement(
            'div',
            { className: 'profile-avatar' },
            (feedUser.feedUserId.type === _feedUserType2.default.Hudl || feedUser.feedUserId.type === _feedUserType2.default.Unknown) && _react2.default.createElement(_Uniform.AvatarOrg, {
              size: 'medium',
              imageUrl: profileImage,
              initials: initials,
              className: 'uni-margin--half--right',
              onClick: this.onProfileClick }),
            feedUser.feedUserId.type === _feedUserType2.default.Team && _react2.default.createElement(_Uniform.AvatarTeam, {
              size: 'medium',
              imageUrl: profileImage,
              className: 'uni-margin--half--right',
              onClick: this.onProfileClick }),
            feedUser.feedUserId.type === _feedUserType2.default.User && _react2.default.createElement(_Uniform.AvatarUser, {
              size: 'medium',
              imageUrl: profileImage,
              initials: initials,
              className: 'uni-margin--half--right',
              onClick: this.onProfileClick }),
            _react2.default.createElement(
              'div',
              { className: 'user-fields' },
              _react2.default.createElement(
                'div',
                { className: 'user-fields-container' },
                _react2.default.createElement(
                  _Uniform.Subhead,
                  { level: 'small', className: 'uni-margin--one-and-half--right' },
                  _react2.default.createElement(
                    'div',
                    { className: 'username open-profile', onClick: this.onClickProfile },
                    _react2.default.createElement(
                      'span',
                      null,
                      name
                    )
                  )
                )
              )
            )
          )
        ),
        this.shouldShowFollowButton() && _react2.default.createElement(_FollowUserButton2.default, {
          feedUserId: this.props.feedUser.feedUserId })
      );
    }
  }]);

  return FollowUserLink;
}(_react.PureComponent);

FollowUserLink.propTypes = {
  currentUserId: _react.PropTypes.string,
  feedUser: _propTypes.FeedUser.isRequired,
  showMiniProfile: _react.PropTypes.func.isRequired,
  onProfileClick: _react.PropTypes.func,
  logData: _react.PropTypes.object
};


function mapStateToProps(state, ownProps) {
  var isFollowing = void 0;
  if (state.follow) {
    var feedUser = ownProps.feedUser;

    var feedUserKey = feedUser && feedUser.feedUserId.type + '-' + feedUser.feedUserId.relatedId;
    isFollowing = state.follow.userFollows && state.follow.userFollows[feedUserKey];
  }

  return {
    isFollowing: isFollowing
  };
}

var mapDispatchToProps = {
  getIsFollowing: _actionCreators.getIsFollowing,
  followUser: _actionCreators.followUser,
  showMiniProfile: _actionCreators.showMiniProfile,
  unfollowUser: _actionCreators.unfollowUser
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FollowUserLink);